import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://indique-um-amigo.hostgator.com.br',
  headers: {
    'Content-Type': 'application/json',
  },
});

const get = ({
  url, headers, signal,
}) => instance.get(url, { headers, signal });

const post = ({
  url, headers, data, signal,
}) => instance.post(url, data, { headers, signal });

const put = ({
  url, headers, data, signal,
}) => instance.put(url, data, { headers, signal });

const useDelete = ({
  url, headers, signal,
}) => instance.delete(url, { headers, signal });

const patch = ({
  url, headers, data, signal,
}) => instance.patch(url, data, { headers, signal });

const extole = {
  instance,
  get,
  post,
  put,
  useDelete,
  patch,
};

export default extole;
